/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCompile } from '../../factoriesAny.js';
export var compileDependencies = {
  parseDependencies,
  typedDependencies,
  createCompile
};